// React dependencies
import React from 'react';

// External dependencies
import PropTypes from 'prop-types';

// Internal dependencies
import Colours from '../../../../styles/colours';

const PhotoLocationIcon = (props) => (
  <div
    className={props.className}
    style={{
      transform:       'translate(-50%, -50%)',
      transformOrigin: 'center center',
      width:           props.size,
      height:          props.size,
      borderRadius:    props.size,
      borderWidth:     '4px',
      borderColor:     props.withShadow ? Colours.White : 'none',
      boxShadow:       props.withShadow ? '0 0 20px rgba(0, 0, 0, 0.6)' : 'none',
      backgroundColor: Colours.OrangePoiMarker,
      ...props.style,
    }}
  />
);

PhotoLocationIcon.propTypes = {
  className:  PropTypes.string,
  style:      PropTypes.shape({}),
  size:       PropTypes.oneOf([PropTypes.string, PropTypes.number]),
  withShadow: PropTypes.bool,
};

PhotoLocationIcon.defaultProps = {
  className:  '',
  style:      {},
  size:       '15px',
  withShadow: false,
};

export default PhotoLocationIcon;
